export const GiftCardValidators = {
  cardNumber(value) {
    if (!value) {
      return 'required';
    }
    if (value.length !== 12 && value.length !== 19) {
      return 'min_length';
    }
    return null;
  },
  cardPin(value) {
    if (!value) {
      return 'required';
    }
    if (!/^\d+$/.test(value)) {
      return 'special_characters';
    }
    if (value.length !== 4) {
      return 'min_length';
    }
    return null;
  },
};
